var map = {
	"./customer/store.js": 11611,
	"./material/store.js": 19070,
	"./product/store.js": 92092,
	"./project/store.js": 7397,
	"./quotation/store.js": 12697,
	"./rating/store.js": 48954,
	"./report/store.js": 19077,
	"./service/store.js": 36068,
	"./settings/store.js": 69902,
	"./ticket/store.js": 29175,
	"./user/store.js": 81224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81783;